import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const TimeSheetComponent = () => {
  return (
    <div className="mt-4">
      <Container fluid>
        <Outlet />
      </Container>
    </div>
  );
};
export default TimeSheetComponent;
